module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', _vm._l((_vm.orderedItems), function(row) {
    return (_vm.orderedItems) ? _c('tr', {
      staticClass: "table-row",
      class: _vm.setCustomClassRow(row)
    }, [(_vm.body.selection && _vm.body.selection.active) ? _c('td', [_c('checkbox', {
      attrs: {
        "checked": row.selected
      },
      on: {
        "input": function($event) {
          return _vm.callEventSelection($event, row)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.header.list), function(value, key) {
      return _c('td', {
        class: _vm.setCustomClassCell(key),
        on: {
          "click": function($event) {
            return _vm.callEventRow(row)
          }
        }
      }, [((_vm.body.customCells !== undefined && _vm.body.customCells[key] !== undefined && (typeof _vm.body.customCells[key](row) == 'string' || typeof _vm.body.customCells[key](row) == 'number'))) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.body.customCells[key](row))
        }
      }) : (
        _vm.body.customCells &&
        _vm.body.customCells[key] &&
        typeof _vm.body.customCells[key](row) === 'object' &&
        _vm.body.customCells[key](row).component) ? [_c(_vm.body.customCells[key](row).component, {
        tag: "component",
        attrs: {
          "arguments": _vm.body.customCells[key](row).arguments
        }
      })] : (
        _vm.body.customCells &&
        _vm.body.customCells[key] &&
        typeof _vm.body.customCells[key](row) === 'object' &&
        (_vm.body.customCells[key](row).html || _vm.body.customCells[key](row).tooltip) &&
        !_vm.body.customCells[key](row).component
      ) ? _c('span', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (_vm.body.customCells[key](row).tooltip),
          expression: "body.customCells[key](row).tooltip"
        }],
        domProps: {
          "innerHTML": _vm._s(_vm.body.customCells[key](row).html)
        }
      }) : _c('span', [_vm._v(_vm._s(row[key]))])], 2)
    }), _vm._v(" "), (_vm.actions.list && _vm.actions.list.length > 0) ? _c('td', [_c(_vm.actionsTemplateSelection, {
      tag: "component",
      attrs: {
        "row": row,
        "actions": _vm.actions
      }
    })], 1) : _vm._e()], 2) : _c('tr', [_c('td', [_vm._v("Loading items ...")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b69bed"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/list/baseBody.vue
// module id = 1624
// module chunks = 0